import React, { useEffect, useState, useRef } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ExcelJS from "exceljs";

import {
  Box,
  Stack,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Grid,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import AttachmentRed from "../../images/attachment-red.svg";
import AttachmentGreen from "../../images/attachment-green.svg";
import Download from "../../images/Download.svg";
import Print from "../../images/Print.svg";
import { INVOICE_LIST } from "../../constants/RoutePath";
import { useLocation, useNavigate } from "react-router-dom";
import { jsPDF } from "jspdf";
import { AccountCircle } from "@mui/icons-material";
import pdfMainLogo from "../../images/HOS-preview-logo.svg";
import Paper from "@mui/material/Paper";
import {
  GET_REPOT_BILLING_STATEMENT,
  GET_BILLING_STATEMENT_BY_ID_URL,
  GET_CUSTOMER_BY_ID_URL,
  USERS_BY_ID_URL,
  GET_PROJECT_DETAILS_BY_ID_URL,
  GET_DASHBOARD_BILLING_STATEMENT_BY_ID_URL,
} from "../../constants/ApiRoute";
import API from "../comman/API";
import { deCryptFun, enCryptFun } from "../comman/CustomFunction";
import {
  authHeader,
  getLogUserId,
  getStatementId,
} from "../comman/MainFunction";
import CustomPageLoading from "../comman/CustomPageLoading";
const moment = require("moment");
import html2canvas from "html2canvas";
import htmlDocx from "html-docx-js/dist/html-docx";
//import htmlDocx from 'html-to-docx';
import * as XLSX from "xlsx";
import { useToast } from "../comman/CustomMessages";
//import htmlDocx from 'html-docx-js';

const billTypeList = [
  { id: 1, name: "Abstract" },
  { id: 2, name: "Mineral" },
  { id: 3, name: "Tract" },
  { id: 4, name: "Cursory Title" },
  { id: 5, name: "Due Dilligence" },
  { id: 6, name: "Area Checks" },
  { id: 7, name: "Curative" },
  { id: 8, name: "Other" },
];

export default function PrintBrokerView(props) {
  const pdfExportComponent = React.useRef(null);
  const captureRef = useRef();
  const [downloadType, setDownloadType] = React.useState("Save as");
  const [loading, setLoading] = useState(false);
  const pathname = window.location.pathname;
  const parts = pathname.split("/");
  const lastPart = parts[parts.length - 1];
  let billingStatementId = isNaN(lastPart) ? null : lastPart;
  const showToast = useToast();
  const [numPages, setNumPages] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [billngStatementData, seBillngStatementData] = useState([]);
  const [overAllTotal, setOverAllTotal] = useState(0);
  const [billingStatementDetail, setBillingStatementDetail] = useState("");
  const [billngStatementTableData, seBillngStatementTableData] = useState([]);
  const [dayRateMillageRateForBilling, setDayRateMillageRateForBilling] =
    useState({});
  console.log(
    billngStatementTableData,
    "billngStatementTableDatabillngStatementTableData"
  );
  console.log(
    dayRateMillageRateForBilling,
    "billngStatementTableDatabillngStatementTableData"
  );
  console.log(
    billngStatementData,
    "billngStatementTableDatabillngStatbillngStatementDataementTableData"
  );
  console.log(
    billingStatementDetail,
    "billngStatemebillingStatementDetailDataementTableData"
  );
  const [customerDetail, setCustomerDetail] = useState("");
  const [brokerDetail, setBrokerDetail] = useState("");
  const [zoomPgae, setZoomPgae] = useState(0);
  const [fullPageView, setFullPageView] = useState(false);
  const [currentPrintDate, setCurrnetPrintDate] = useState("");
  console.log(fullPageView, "kahdjahdjhajdhjahjgdjdgjhdaghda");
  console.log(overAllTotal, "kazoomPgaehdjahdjhajdhjahjgdjdgjhdaghda");
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(0);

  const pageLoad = () => {
    setCurrentPage(0);
    setZoomPgae(0);
    setFullPageView(false);
    setDownloadType("Save as");
    getBillingStatementPrintViewDetail(billingStatementId);
    getBillingStatement(billingStatementId);
  };

  useEffect(() => {
    if (billingStatementId) {
      getBillingStatementPrintViewDetail(billingStatementId);
      getBillingStatement(billingStatementId);
    }
  }, [billingStatementId]);

  useEffect(() => {
    if (billngStatementData && billngStatementData[0]) {
      let charges = 0;
      let expense = 0;
      let mileageRate = 0;

      // Calculate Expense
      expense =
        (Number(billngStatementData[0].Copies) || 0) +
        (Number(billngStatementData[0].Lodging) || 0) +
        (Number(billngStatementData[0].Misc) || 0);

      // Calculate Mileage Rate
      const miles = Number(billngStatementData[0].Miles) || 0;
      const defaultMileageRate =
        dayRateMillageRateForBilling?.brokerBilling?.millageRate || 0;
      const currentMileageRate =
        billngStatementData[0]?.MileageRate === defaultMileageRate ||
        billngStatementData[0]?.StatusID !== 1
          ? billngStatementData[0]?.MileageRate
          : defaultMileageRate;

      mileageRate = miles * (Number(currentMileageRate) || 0);

      // Calculate Charges
      const hours = Number(billngStatementData[0].Hours) || 0;
      const dayRate =
        billngStatementData[0]?.StatusID !== 1 ||
        billngStatementData[0]?.DayRate ===
          dayRateMillageRateForBilling?.brokerBilling?.dayRate
          ? billngStatementData[0]?.DayRate
          : dayRateMillageRateForBilling?.brokerBilling?.dayRate;

      charges = (hours / 8) * (Number(dayRate) || 0);

      // Calculate Overall Total
      const perDiem = Number(billngStatementData[0].PerDiem) || 0;

      setOverAllTotal((charges + expense + mileageRate + perDiem).toFixed(2));
    }
  }, [
    billngStatementData,
    billingStatementDetail,
    dayRateMillageRateForBilling,
  ]);

  const itemsPerPage = 10;

  // Calculate the total number of pages
  const totalPages =
    Math.ceil(billngStatementTableData.length / itemsPerPage) == 0
      ? "1"
      : Math.ceil(billngStatementTableData.length / itemsPerPage);

  console.log(currentPage, "currentPagecurrentPage", totalPages);
  const currentPageData = billngStatementTableData.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  // Navigation handlers
  const handleNextPage = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 0) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const handleFirstPage = () => {
    setCurrentPage(0);
  };

  const handleLastPage = () => {
    setCurrentPage(totalPages - 1);
  };

  const getBillingStatementPrintViewDetail = async (billingStatementId) => {
    let data = {
      billingStatementId: billingStatementId,
    };

    const config = {
      method: "GET",
      url: GET_REPOT_BILLING_STATEMENT,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      console.log(parsedResponse);

      if (parsedResponse.data && parsedResponse.data.length > 0) {
        seBillngStatementData(parsedResponse.data);

        if (parsedResponse.data[0] && parsedResponse.data[0].BillingDetails) {
          const billingDetailsJSON = JSON.parse(
            parsedResponse.data[0].BillingDetails
          );

          const sortedDataAsc = billingDetailsJSON.sort(
            (a, b) => new Date(a.Date) - new Date(b.Date)
          );

          console.log(
            billingDetailsJSON,
            "billingDetailsJSONbillingDetailsJSON"
          );
          const filteredDatte = sortedDataAsc?.filter(
            (item) => item.BillingType !== 0
          );
          seBillngStatementTableData(filteredDatte);
          // seBillngStatementTableData(sortedDataAsc);
        }
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
      }
      return null; // Return null on error
    }
  };

  const getBillingStatement = async (billingStatementId) => {
    setLoading(true);
    let data = {
      billingStatementId: billingStatementId,
      isOrphaned: 0,
    };
    const config = {
      method: "GET",
      url: GET_DASHBOARD_BILLING_STATEMENT_BY_ID_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        setCurrnetPrintDate(moment().utc().format("MM/DD/YYYY h:mm:ss A"));
        const {
          BillingStart,
          BillingEnd,
          Hours,
          Miles,
          Lodging,
          Copies,
          Misc,
          DayRate,
          PerDiem,
          MileageRate,
          Total,
          StatusID,
          UserID,
          PeriodKey,
          ProjectID,
          CustomerName,
          BrokerName,
          ProjectName,
          CustomerId,
        } = parsedResponse.billingStatementDetails[0];

        setBillingStatementDetail(parsedResponse.billingStatementDetails[0]);

        setDayRateMillageRateForBilling((prevState) => ({
          ...prevState,
          brokerBilling: {
            ...prevState.brokerBilling,
            dayRate: DayRate,
            millageRate: MileageRate,
          },
        }));

        console.log(
          "parsedResponse.billingStatementDetails[0]",
          parsedResponse.billingStatementDetails[0]
        );
        getBrokerDetail(UserID);
        getCustomerDetail(CustomerId);
        if (StatusID == 1) {
          getBillingProjectDetail(ProjectID);
        }
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v?.message?.message, "error");

        setTimeout(() => {
          // Attempt to close only if the tab was opened programmatically
          const canClose = window.opener != null; // Check if this window has a parent
          if (canClose) {
            window.close();
          } else {
            navigate("/billingstatement");
            // showToast("Please close this tab manually.", "error");
          }
        }, 2000);
      }
    } finally {
      setLoading(false);
    }
  };

  const getBrokerDetail = async (brokerId) => {
    const d1 = {
      userId: brokerId,
    };
    const config = {
      method: "GET",
      url: USERS_BY_ID_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(d1)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status == "Success") {
        console.log("Broker Detail", parsedResponse.data[0]);
        setBrokerDetail(parsedResponse.data[0]);
      }
    } catch (error) {}
  };

  const getCustomerDetail = async (customerId) => {
    const d1 = {
      userId: customerId,
    };
    const config = {
      method: "GET",
      url: GET_CUSTOMER_BY_ID_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(d1)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status == "Success") {
        console.log("Customer Detail", parsedResponse.data[0]);
        setCustomerDetail(parsedResponse.data[0]);
      }
    } catch (error) {}
  };

  const getBillingProjectDetail = async (ProjectID) => {
    let data = {
      projectId: ProjectID,
    };
    const config = {
      method: "GET",
      url: GET_PROJECT_DETAILS_BY_ID_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status == "Success") {
        const { BrokerDetails, ProjectDetails } = parsedResponse;

        var activeBrokers = BrokerDetails.find(function (broker) {
          return broker.Active === true;
        });

        const newvalBroker = BrokerDetails.filter((item) => {
          return item?.UserID === getLogUserId();
        });

        console.log(activeBrokers, "jhaskjdhjakdhskjhdkajshd");
        console.log(newvalBroker, "jhaskjnewvalBrokerdhjakdhskjhdkajshd");

        // if (
        //   (newvalBroker && newvalBroker[0] && newvalBroker[0].DayRate) ||
        //   (activeBrokers && activeBrokers?.DayRate)
        // ) {
          setDayRateMillageRateForBilling((prevState) => ({
            ...prevState,
            brokerBilling: {
              ...prevState.brokerBilling,
              millageRate:
                ProjectDetails &&
                ProjectDetails[0] &&
                ProjectDetails[0].MileageRate,
            },
          }));
        // }
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
      }
    }
  };
  const handleChangeDownloadType = (event) => {
    var selectedValue = event.target.value;
    setLoading(true);
    setDownloadType(selectedValue);
    setFullPageView(true);
    setZoomPgae(0);
    setTimeout(() => {
      if (selectedValue === "DOC") {
        textFileDownloadSection();
      } else if (selectedValue === "IMAGE") {
        imageFileDownloadSection();
      } else if (selectedValue === "PDF") {
        pdfFileDownloadSection();
      } else if (selectedValue === "EXCEL") {
        excelFileDownloadSection();
      }
    }, 1500);
  };
  const handleChangeZoomPage = (event) => {
    let selectedValue = event.target.value;
    console.log(selectedValue, "selectedValue");
    // Treat both 0.00 and 0 as "Whole Page" / "100%"
    // if (selectedValue === 0) {
    //   setZoomPgae(0);
    //   setDefaultZoomLabel("Whole Page");
    // } else if (selectedValue === 100) {
    //   setZoomPgae(100);
    //   setDefaultZoomLabel("100%");
    // } else {
    //   setZoomPgae(selectedValue);
    //   setDefaultZoomLabel(`${selectedValue}%`);
    // }

    setZoomPgae(selectedValue);
  };

  // const imageFileDownloadSection = async () => {
  //   const element = document.getElementById("capturediv");

  //   if (element) {
  //     // Create a wrapper div for consistent padding
  //     const wrapper = document.createElement("div");
  //     wrapper.style.padding = "50px"; // Adjust padding as needed
  //     wrapper.style.backgroundColor = "white"; // Optional: to avoid transparency issues
  //     wrapper.style.boxSizing = "border-box"; // Ensure padding is included in dimensions

  //     // Clone the original element into the wrapper
  //     const clonedElement = element.cloneNode(true);
  //     wrapper.appendChild(clonedElement);

  //     // Append wrapper to the body temporarily for rendering
  //     document.body.appendChild(wrapper);

  //     // Adjust canvas scaling to handle zoom
  //     const scale = 1 / (window.devicePixelRatio || 1); // Get current zoom level
  //     const canvas = await html2canvas(wrapper, {
  //       scale, // Adjust the canvas to render at 100%
  //       useCORS: true, // Enable cross-origin handling if required
  //     });

  //     // Create a downloadable image from the canvas
  //     const dataURL = canvas.toDataURL("image/png");
  //     const link = document.createElement("a");
  //     link.href = dataURL;
  //     link.download = "BillingStatement.png";
  //     link.click();

  //     // Remove the temporary wrapper from the DOM
  //     document.body.removeChild(wrapper);

  //     setFullPageView(false);
  //     setDownloadType('Save as');
  //   }
  // };

  async function imageFileDownloadSection() {
    const element = captureRef.current;

    if (element) {
      // Create a wrapper div for consistent padding
      const wrapper = document.createElement("div");
      wrapper.style.padding = "50px"; // Adjust padding as needed
      wrapper.style.backgroundColor = "white"; // Optional: to avoid transparency issues
      wrapper.style.boxSizing = "border-box"; // Ensure padding is included in dimensions

      // Clone the original element into the wrapper
      const clonedElement = element.cloneNode(true);
      wrapper.appendChild(clonedElement);

      // Append wrapper to the body temporarily for rendering
      document.body.appendChild(wrapper);

      // Capture the wrapper using html2canvas
      const canvas = await html2canvas(wrapper);
      const dataURL = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = dataURL;
      link.download = "BillingStatement.png";
      link.click();

      document.body.removeChild(wrapper);

      setFullPageView(false);
      setDownloadType("Save as");
      setLoading(false);
    }
    setLoading(false);
  }

  const textFileDownloadSection = () => {
    const emailTemplate = `
<div style="font-family: Arial, sans-serif; padding: 10px; color: #333;">

  <table style="width: 100%; margin-top: 10px;">
          <tr>
            <td style="text-align: left; padding-right: 10px; vertical-align: top;">
              <img src="https://hosv2dev.blob.core.windows.net/hosv2dev/HOS-logo_2024-11-29-05-45-04.png" alt="Logo" height="60px" width="50%"/>
            </td>
            <td style="text-align: right; padding-left: 10px; vertical-align: top;padding-right:10px">
            <div style="border-right:solid 4px #58A84A;height:50px;">   
            <p style="margin: 0;color: #212121;
text-align: right; font-size: 12px; font-style: normal; font-weight: 400;line-height: normal;">TOTAL DUE</p>
               <p style="margin: 0; color: #2F9D41;color: #212121; font-size: 24px; font-style: normal;
font-weight: 700; line-height: normal;"><strong>$${
      overAllTotal ? overAllTotal : "0.00"
    }</strong></p>
    </div>
            </td>
          </tr>
  </table>

  <br />

  <table style="width: 100%; margin-top: 10px;">
          <tr>
            <td style="text-align: left; padding-right: 10px; vertical-align: top;">
              <h3 style="margin: 0;color: #333843;font-size: 15px;font-style: normal;
font-weight: 700;line-height: 140%; /* 21px */letter-spacing: 0.075px;"><b> ${
      billngStatementData[0] ? billngStatementData[0].ProjectName : ""
    } (${
      billngStatementData[0] ? billngStatementData[0].ProjectID : ""
    }) </b></h3>
              <p style="margin: 0;color: #667085;font-size: 13px;font-style: normal;font-weight: 400;
line-height: 132%; /* 17.16px */letter-spacing: 0.065px;"">${
      billngStatementData[0] ? billngStatementData[0].BrokerName : ""
    }<br />97223041054 | om@om.com</p>
            </td>
            <td style="text-align: right; padding-left: 10px; vertical-align: top;">
              <h3 style="margin: 0;color: #333843;font-size: 15px;font-style: normal;
font-weight: 700;line-height: 140%; /* 21px */letter-spacing: 0.075px;"><b> ${
      billngStatementData[0] ? billngStatementData[0].ProjectName : ""
    } (${
      billngStatementData[0] ? billngStatementData[0].ProjectID : ""
    }) </b></h3>
              <p style="margin: 0;color: #667085;font-size: 13px;font-style: normal;font-weight: 400;
line-height: 132%; /* 17.16px */letter-spacing: 0.065px;">
                ${
                  billngStatementData[0]
                    ? billngStatementData[0].BrokerName
                    : ""
                }<br />
                97223041054 | om@om.com<br />
                111-222-3333
              </p>
            </td>
          </tr>
  </table>


  <br />


  <table style="width: 100%; margin-top: 20px; border-collapse: collapse; background-color: #f2f2f2;  border-spacing: 0px 3px;">
          <tr>
            <th style="padding: 0px 10px; text-align: center; background-color: #F2F2F2;">Hours
              <span style="font-size: 12px;color: #667085 !important;"><br/>sum of all hours</span>
            </th>
            <th style="padding: 0px 10px; text-align: center; background-color: #F2F2F2;">Day Rate
              <span style="font-size: 12px;color: #667085 !important;"><br/>amount paid per 8 hours</span>
            </th>
            <th style="padding: 0px 10px; text-align: center; background-color: #F2F2F2;">Per Diem
              <span style="font-size: 12px;color: #667085 !important;"><br/>total per diem</span>
            </th>
            <th style="padding: 0px 10px; text-align: center; background-color: #F2F2F2;">Expenses
              <span style="font-size: 12px;color: #667085 !important;"><br/>loding, copies & misc</span>
            </th>
            <th style="padding: 0px 10px; text-align: center; background-color: #F2F2F2;">Miles
              <span style="font-size: 12px;color: #667085 !important;"><br/>
              ${
                billngStatementData[0]
                  ? billngStatementData[0].Miles.toFixed(2)
                  : "0.00"
              } miles * $${
      billngStatementData[0]
        ? billingStatementDetail?.MileageRate ===
            dayRateMillageRateForBilling?.brokerBilling?.millageRate ||
          billingStatementDetail?.StatusID !== 1
          ? billingStatementDetail?.MileageRate.toFixed(3)
          : dayRateMillageRateForBilling?.brokerBilling?.millageRate || 0.0
        : "0.00"
    } / mile
              </span>
            </th>
             <th style="padding: 0px 10px; text-align: center; background-color: #F2F2F2;">Total Owed<br>
        <span style="font-size: 12px;color: #667085 !important;">total owed to broker</span></th>
          </tr>
          <tr style="margin-top: -15px;border-bottom: 1px solid #ededed;">
            <td style="text-align: center;line-height:100%;padding: 2px 5px;color:#333843;font-size: 18px;
font-style: normal; font-weight: 700; line-height: 140%; /* 25.2px */ letter-spacing: 0.09px;">${
      billngStatementData[0] ? billngStatementData[0].Hours.toFixed(2) : "0.00"
    }</td>
            <td style="text-align: center;line-height:100%;padding: 2px 5px;color:#333843;font-size: 18px;
font-style: normal; font-weight: 700; line-height: 140%; /* 25.2px */ letter-spacing: 0.09px;">$${
      billngStatementData[0]
        ? "$" + billngStatementData && dayRateMillageRateForBilling
          ? billngStatementData[0].DayRate ==
              dayRateMillageRateForBilling?.brokerBilling?.dayRate ||
            billngStatementData[0]?.StatusID != 1
            ? billngStatementData[0].DayRate.toFixed(2)
            : dayRateMillageRateForBilling?.brokerBilling?.dayRate
          : 0.0
        : "0.00"
    }</td>
            <td style="text-align: center;line-height:100%;padding: 2px 5px;color:#333843;font-size: 18px;
font-style: normal; font-weight: 700; line-height: 140%; /* 25.2px */ letter-spacing: 0.09px;">${
      billngStatementData[0]
        ? "$" + billngStatementData[0].PerDiem.toFixed(2)
        : "0.00"
    }</td>
            <td style="text-align: center;line-height:100%;padding: 2px 5px;color:#333843;font-size: 18px;
font-style: normal; font-weight: 700; line-height: 140%; /* 25.2px */ letter-spacing: 0.09px;">$${
      billngStatementData[0]
        ? (
            (billngStatementData[0].Copies
              ? billngStatementData[0].Copies
              : 0) +
            (billngStatementData[0].Lodging
              ? billngStatementData[0].Lodging
              : 0) +
            (billngStatementData[0].Misc ? billngStatementData[0].Misc : 0)
          ).toFixed(2)
        : "0.00"
    }</td>
        <td style="text-align: center;line-height:100%;padding: 2px 5px;color:#333843;font-size: 18px;
font-style: normal; font-weight: 700; line-height: 140%; /* 25.2px */ letter-spacing: 0.09px;">$${
      billngStatementData[0]
        ? (
            (billngStatementData[0].Miles ? billngStatementData[0].Miles : 0) *
            (billingStatementDetail?.MileageRate ===
              dayRateMillageRateForBilling?.brokerBilling?.millageRate ||
            billingStatementDetail?.StatusID !== 1
              ? billingStatementDetail?.MileageRate.toFixed(3)
              : dayRateMillageRateForBilling?.brokerBilling?.millageRate || 0.0)
          ).toFixed(3)
        : "0.00"
    }</td>
        <td style="text-align: center;line-height:100%;padding: 2px 5px;color:#333843;font-size: 18px;
font-style: normal; font-weight: 700; line-height: 140%; /* 25.2px */ letter-spacing: 0.09px;">$${
      overAllTotal ? overAllTotal : "0.00"
    }</td>
          </tr>
        </table>

  <br />
      <table style="width: 100%; border-collapse: collapse;">
        <thead>
        <tr style="background-color: #4CAF50; color: white;">
          <th style="padding: 10px; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 400; line-height: normal;">Date</th>
          <th style="padding: 10px; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 400; line-height: normal;">Type</th>
          <th style="padding: 10px; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 400; line-height: normal;">Hours</th>
          <th style="padding: 10px; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 400; line-height: normal;">Miles</th>
          <th style="padding: 10px; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 400; line-height: normal;">Lodging</th>
          <th style="padding: 10px; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 400; line-height: normal;">Copies</th>
          <th style="padding: 10px; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 400; line-height: normal;">Misc</th>
          <th style="padding: 10px; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 400; line-height: normal;">Per Diem</th>
        </tr>
      </thead>
      <tbody>
        ${billngStatementTableData
          .filter((item) => item.BillingType !== 0)
          .sort((a, b) => {
            // First sort by BillingDetailsID
            if (a.BillingDetailsID !== b.BillingDetailsID) {
              return a.BillingDetailsID - b.BillingDetailsID;
            }
            // If BillingDetailsID is the same, sort by Date
            return new Date(a.Date) - new Date(b.Date);
          })
          .map(
            (billingDetail) => `
            <tr style="border-bottom: 1px solid #ededed;">
              <td style="padding: 10px;padding-bottom: 0px;text-align: left;border-bottom: 1px solid #ededed;">
                <span>${moment
                  .utc(billingDetail.Date)
                  .format("MM/DD/YYYY")}</span><br/>
                  <span style="color: #667085;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 132%; 
                    letter-spacing: 0.06px;
                    word-break: break-word;"
                    >
                  ${
                    billingDetail.Description ? billingDetail.Description : "--"
                  }</span>
              </td>
              <td style="padding: 10px;padding-bottom: 0px;text-align: left;border-bottom: 1px solid #ededed;">${
                billTypeList.find((row) => row.id === billingDetail.BillingType)
                  ? billTypeList.find(
                      (row) => row.id === billingDetail.BillingType
                    ).name
                  : "--"
              }</td>
              <td style="padding: 10px;padding-bottom: 0px;text-align: left;border-bottom: 1px solid #ededed;">${
                billingDetail.Hours ? billingDetail.Hours.toFixed(2) : "0.00"
              }</td>
              <td style="padding: 10px;padding-bottom: 0px;text-align: left;border-bottom: 1px solid #ededed;">${
                billingDetail.Miles ? billingDetail.Miles.toFixed(2) : "0.00"
              }</td>
              <td style="padding: 10px;padding-bottom: 0px;text-align: left;border-bottom: 1px solid #ededed;">${
                billingDetail.Lodging
                  ? billingDetail.Lodging.toFixed(2)
                  : "0.00"
              }</td>
              <td style="padding: 10px;padding-bottom: 0px;text-align: left;border-bottom: 1px solid #ededed;">${
                billingDetail.Copies ? billingDetail.Copies.toFixed(2) : "0.00"
              }</td>
              <td style="padding: 10px;padding-bottom: 0px;text-align: left;border-bottom: 1px solid #ededed;">${
                billingDetail.Misc ? billingDetail.Misc.toFixed(2) : "0.00"
              }</td>
              <td style="padding: 10px;padding-bottom: 0px;text-align: left;border-bottom: 1px solid #ededed;">${
                billingDetail.PerDiem
                  ? billingDetail.PerDiem.toFixed(2)
                  : "0.00"
              }</td>
            </tr>
          `
          )
          .join("")}
      </tbody>
    </table>

  <br />

  <div style="margin-top: 40px; color: #000; text-align: center; font-size: 12px;font-style: normal;
font-weight: 400;line-height: 132%; /* 13.2px */letter-spacing: 0.05px">
          <p>&copy; 2018 HOS Resources, LLC. All Rights Reserved.
         910 Harding Street Lafayette, LA 70503.
          337.889.3940 | <a href="https://hosresources.com/" target="_blank">www.hosresources.com</a>
          </p>
  </div>

        <table style="width: 100%; background-color: #4CAF50; color: white; padding: 10px; border-radius: 5px; border-collapse: collapse;">
          <tr>
            <td style="text-align: center; padding: 5px;">
              <p style="margin: 0;color: #FFF; font-size: 12px;font-style: normal;
font-weight: 400; line-height: normal;">910 Harding Street<b/>Lafayette, LA 70503</p>
            </td>
            <td style="text-align: center; padding: 5px;">
              <p style="margin: 0;color: #FFF; font-size: 12px;font-style: normal;
font-weight: 400; line-height: normal;">P.O. Box 51794<b/> Lafayette, LA 70505</p>
            </td>
            <td style="text-align: center; padding: 5px;">
              <p style="margin: 0;color: #FFF; font-size: 12px;font-style: normal;
font-weight: 400; line-height: normal;">337.889.8940</p>
            </td>
            <td style="text-align: center; padding: 5px;">
              <p style="margin: 0;color: #FFF; font-size: 12px;font-style: normal;
font-weight: 400; line-height: normal;">www.hosresources.com</p>
            </td>
          </tr>
        </table>
</div>`;

    // Convert the HTML to a DOCX blob
    const converted = htmlDocx.asBlob(emailTemplate);

    // Create a link element
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(converted);
    link.download = "BillingStatement.docx"; // Specify the file name

    // Programmatically click the link to trigger the download
    link.click();
    setFullPageView(false);
    setDownloadType("Save as");
    setLoading(false);
  };

  // async function pdfFileDownloadSection() {
  //   try {
  //     // Get the HTML content
  //     const emailContent = document.getElementById("capturediv");

  //     // Use html2canvas to generate a canvas with styles preserved
  //     const canvas = await html2canvas(emailContent, {
  //       scale: 2, // Adjust for better quality
  //       useCORS: true, // Handles external resources
  //     });

  //     // Get the canvas as a data URL (image)
  //     const imgData = canvas.toDataURL("image/png");

  //     // Initialize jsPDF
  //     const pdf = new jsPDF("p", "mm", "a4");

  //     // Get PDF page dimensions
  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = pdf.internal.pageSize.getHeight();

  //     // Calculate the image dimensions for the PDF
  //     const imgWidth = pdfWidth - 20; // Leave 10mm margin on both sides
  //     const imgHeight = (canvas.height * imgWidth) / canvas.width;

  //     let position = 10; // Initial vertical position on the page
  //     let heightLeft = imgHeight;

  //     // Add the image to the PDF and handle page breaks
  //     while (heightLeft > 0) {
  //       pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
  //       heightLeft -= pdfHeight;
  //       position = -heightLeft;

  //       // Add a new page if there's content remaining
  //       if (heightLeft > 0) {
  //         pdf.addPage();
  //         position = 10;
  //       }
  //     }

  //     // Save the generated PDF
  //     pdf.save("BillingStatement.pdf");

  //     // Reset view and other states
  //     setFullPageView(false);
  //     setDownloadType("Save as");
  //   } catch (error) {
  //     console.error("Error generating PDF:", error);
  //     alert("An error occurred while generating the PDF.");
  //   }
  // }

  async function pdfFileDownloadSection() {
    // Get the HTML content
    const emailContent = document.getElementById("capturediv");

    // Use html2canvas to create a canvas from the HTML content
    const canvas = await html2canvas(emailContent, { scale: 2, useCORS: true }); // Added useCORS for external images
    const imgData = canvas.toDataURL("image/png");

    // Create a new jsPDF instance
    const pdf = new jsPDF("p", "mm", "a4");

    // Page dimensions
    const padding = 10; // Padding for all sides
    const pageWidth = pdf.internal.pageSize.width - padding * 2; // Width with padding
    const pageHeight = pdf.internal.pageSize.height - padding * 2; // Height with padding

    // Calculate the image dimensions
    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    // Number of full pages
    const fullPages = Math.floor(imgHeight / pageHeight);

    // Render the content page by page
    let heightCovered = 0; // Keep track of height already rendered
    for (let i = 0; i <= fullPages; i++) {
      const startY = (heightCovered * canvas.width) / imgWidth; // Calculate the start height on the canvas
      const partHeight = Math.min(pageHeight, imgHeight - heightCovered); // Height of the part to render

      // Create a temporary canvas for the current part
      const tempCanvas = document.createElement("canvas");
      tempCanvas.width = canvas.width;
      tempCanvas.height = (partHeight * canvas.width) / imgWidth;
      const tempCtx = tempCanvas.getContext("2d");

      // Draw the current part onto the temporary canvas
      tempCtx.drawImage(canvas, 0, -startY);

      // Convert the temporary canvas to a data URL
      const partImgData = tempCanvas.toDataURL("image/png");

      // Add the image to the PDF
      pdf.addImage(partImgData, "PNG", padding, padding, imgWidth, partHeight);

      heightCovered += partHeight;

      // Add a new page if there is more content
      if (i < fullPages) {
        pdf.addPage();
      }
    }

    // Save the PDF
    pdf.save("BillingStatement.pdf");

    setFullPageView(false);
    setDownloadType("Save as");
    setLoading(false);
  }

  const excelFileDownloadSection = () => {
    handleExport();
  };

  const handlePrint = () => {
    let printContents = document.getElementById("capturediv").innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload();
    setFullPageView(false);
    setDownloadType("Save as");
  };

  //Excel

  const handleExport = async () => {
    try {
      const workbook = new ExcelJS.Workbook();
      const wsData = workbook.addWorksheet("Report");

      wsData.pageSetup = {
        paperSize: 32, // A4 paper size
        orientation: "Portrait", // Portrait orientation
        fitToPage: true, // Scale content to fit on one page
        fitToWidth: 0, // Fit to one page width
        fitToHeight: 0, // Allow unlimited height
      };

      // Set fixed column widths and wrap text for columns A to AF
      for (let col = 1; col <= 32; col++) {
        // Columns A to AF
        wsData.getColumn(col).width = 15; // Set a fixed width for clarity
        wsData.getColumn(col).alignment = {
          wrapText: false,
          horizontal: "left",
        };
      }

      // Ensure header row cells have proper alignment and sufficient height
      wsData.getRow(1).eachCell({ includeEmpty: true }, (cell) => {
        cell.alignment = {
          horizontal: "center",
          vertical: "middle",
          wrapText: false,
        }; // Center align headers
      });
      wsData.getRow(1).height = 30; // Set a reasonable header row height // Set a reasonable header row height

      // Set wsData view options
      wsData.views = [
        {
          state: "normal",
          showGridLines: false,
        },
      ];

      try {
        const imageUrl =
          "https://hosv2dev.blob.core.windows.net/hosv2dev/HOS-logo_2024-11-29-05-45-04.png?sp=r&st=2024-11-29T19:32:35Z&se=2026-12-31T03:32:35Z&spr=https&sv=2022-11-02&sr=b&sig=vcGmp6ViPLUn73RgVtVmz1NHryyo1uBDmk0ttKqByas%3D";

        console.log("Fetching image from:", imageUrl);
        // Fetch the image as a binary buffer
        const response = await fetch(imageUrl, { method: "GET" });
        if (!response.ok) {
          throw new Error(`Failed to fetch image: ${response.statusText}`);
        }
        const imageBuffer = await response.arrayBuffer();

        // Add the image to the workbook
        const imageId = workbook.addImage({
          buffer: imageBuffer,
          extension: "png",
        });

        // Append the image to the worksheet
        wsData.addImage(imageId, {
          tl: { col: 0, row: 0 }, // Top-left corner where the image starts
          ext: { width: 330, height: 80 }, // Dimensions of the image
        });

        // Add the row for "TOTAL DUE"
        const row = wsData.addRow([
          null, // Leave the first column empty for the image
          null, // Leave the second column empty for the image
          null, // Leave the third column empty for the image
          null, // Leave the first column empty for the image
          null, // Leave the second column empty for the image
          null, // Leave the third column empty for the image
          null, // Leave the first column empty for the image
          {
            richText: [
              { text: "TOTAL DUE: ", font: { bold: false } },
              {
                text: ` $${overAllTotal || 0.0}`,
                font: { bold: true },
              },
            ],
          },
        ]);

        // Adjust column widths for proper alignment
        wsData.getColumn(1).width = 12; // Image column
        wsData.getColumn(3).width = 25; // Total due column

        console.log("Image successfully added to Excel.");
      } catch (error) {
        console.error("Error fetching or adding image:", error);
        return; // Exit if image addition fails
      }
      wsData.addRow([]);
      wsData.addRow([]);

      function addStyledCell2(
        row,
        startColumn,
        content,
        mergeColumns = 2,
        alignment = "left"
      ) {
        const endColumn = startColumn + mergeColumns - 1;

        // Merge cells for the object.
        wsData.mergeCells(row.number, startColumn, row.number, endColumn);

        // Get the first cell in the merged range to apply styling.
        const cell = row.getCell(startColumn);
        cell.value = { richText: content };
        cell.alignment = {
          wrapText: true,
          vertical: "middle",
          horizontal: alignment, // Dynamic alignment based on parameter
        };

        // Apply background color to the merged range.
        for (let col = startColumn; col <= endColumn; col++) {
          const currentCell = row.getCell(col);
          currentCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "F6F7F9" },
          }; // Gray background
        }

        return startColumn + mergeColumns; // Return next start column.
      }

      // Create a new row and apply the styled cell function.
      const row4 = wsData.addRow([]);
      row4.height = 20;
      let startColumn4 = 1;

      // Add the "Billing Statement" on the left (spans 7 columns).
      startColumn4 = addStyledCell2(
        row4,
        startColumn4,
        [
          {
            text: `Billing Statement: ${moment(
              billngStatementData[0].BillingStart
            )
              .utc()
              .format("MM/DD/YYYY")} - ${moment(
              billngStatementData[0].BillingEnd
            )
              .utc()
              .format("MM/DD/YYYY")}\n`,
            font: { bold: true },
          },
        ],
        7, // Span 7 columns
        "left" // Align text to the left
      );

      // Add the "Print Date" on the right (spans remaining columns).
      addStyledCell2(
        row4,
        startColumn4, // Continue from the next column
        [
          {
            text: `Print Date: ${currentPrintDate}\n`,
            font: { bold: true },
          },
        ],
        2, // Span remaining 2 columns
        "right" // Align text to the right
      );

      wsData.addRow([]);

      function addStyledCell1(
        row,
        startColumn,
        content,
        mergeColumns = 2,
        gapColumns = 1
      ) {
        const endColumn = startColumn + mergeColumns - 1;

        // Merge cells for the object.
        wsData.mergeCells(row.number, startColumn, row.number, endColumn);

        const cell = row.getCell(startColumn);
        cell.value = { richText: content };
        cell.alignment = {
          wrapText: true,
          vertical: "start",
          horizontal: "center",
        };

        return startColumn + mergeColumns + gapColumns; // Return the next start column.
      }

      const row3 = wsData.addRow([]); // Add an empty row first.
      row3.height = 90;
      let startColumn3 = 1; // Start from the first column.

      startColumn3 = addStyledCell1(row3, startColumn3, [
        {
          text: `${
            billngStatementData[0]
              ? billngStatementData[0].ProjectName
              : "" || ""
          } (${billngStatementData[0].ProjectID})\n`,
          font: { bold: true },
        },
        {
          text: `${customerDetail.Name || ""},\n`,
        },
        {
          text: `${customerDetail.ContactOfficePhone || ""},\n`,
        },
        {
          text: `${customerDetail.ContactMobilePhone || ""} | \n`,
        },
        {
          text: `${customerDetail ? customerDetail.ContactEmail : ""}\n`,
        },
      ]);

      // Add two empty columns as a gap.
      startColumn3 = addStyledCell1(
        row3,
        startColumn3,
        [
          {
            text: "",
          },
        ],
        2,
        0
      ); // 2 columns merged as a gap, no additional gap between.

      // Add the second group of project details (3 columns).
      startColumn3 = addStyledCell1(row3, startColumn3, [
        {
          text: `${brokerDetail ? brokerDetail.FirstName : ""}${""}${
            brokerDetail ? brokerDetail.LastName : ""
          }\n`,
          font: { bold: true },
        },
        {
          text: `${brokerDetail ? brokerDetail.PhoneNumber : ""} | ${
            brokerDetail?.Email
          }\n`,
        },
      ]);

      // Ensure all columns are properly set for visual alignment.
      wsData.columns.forEach((col) => {
        col.width = 15; // Adjust column width to ensure content fits.
      });

      wsData.addRow([]);
      wsData.addRow([]);

      const row = wsData.addRow([]); // Add an empty row first

      // Function to add a cell with merged columns, gap, and border
      function addStyledCell(
        row,
        startColumn,
        content,
        mergeColumns = 1,
        gapColumns = 0
      ) {
        const endColumn = startColumn + mergeColumns - 1;

        // Merge cells for the object
        wsData.mergeCells(row.number, startColumn, row.number, endColumn);

        const cell = row.getCell(startColumn);
        cell.value = { richText: content };
        cell.alignment = {
          wrapText: true,
          vertical: "middle",
          horizontal: "center",
        };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6F7F9" },
        }; // Gray background
        cell.border = {
          top: { style: "thin", color: { argb: "FFFFFF" } }, // White border for gap
          left: { style: "thin", color: { argb: "FFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFF" } },
        };

        return startColumn + mergeColumns + gapColumns; // Return next start column
      }

      let startColumn = 2; // Start from the first column
      row.height = 60;
      // Total Hours
      startColumn = addStyledCell(row, startColumn, [
        { text: "Hours\n", font: { bold: true } },
        { text: "sum of all hours\n" },
        {
          text: `${
            billingStatementDetail
              ? billingStatementDetail.Hours.toFixed(2)
              : 0.0
          }`,
          font: { bold: true },
        },
      ]);

      // Broker Charges
      startColumn = addStyledCell(row, startColumn, [
        { text: "Day Rate\n", font: { bold: true } },
        {
          text: "amt paid per 8 hours\n",
        },
        {
          text: `$${
            billingStatementDetail && dayRateMillageRateForBilling
              ? billingStatementDetail.DayRate ==
                  dayRateMillageRateForBilling?.brokerBilling?.dayRate ||
                billingStatementDetail?.StatusID != 1
                ? billingStatementDetail.DayRate.toFixed(2)
                : dayRateMillageRateForBilling?.brokerBilling?.dayRate
              : 0.0
          }`,
          font: { bold: true },
        },
      ]);

      // Per Diem
      startColumn = addStyledCell(row, startColumn, [
        { text: "Per Diem\n", font: { bold: true } },
        { text: "total per diem\n" },
        {
          text: `$${
            billingStatementDetail
              ? billingStatementDetail.PerDiem.toFixed(2)
              : 0.0
          }`,
          font: { bold: true },
        },
      ]);

      startColumn = addStyledCell(row, startColumn, [
        { text: "Expenses\n", font: { bold: true } },
        {
          text: "lodging, copies & misc\n",
        },
        {
          text: `$${
            billingStatementDetail
              ? (
                  (billingStatementDetail.Copies
                    ? billingStatementDetail.Copies
                    : 0) +
                  (billingStatementDetail.Lodging
                    ? billingStatementDetail.Lodging
                    : 0) +
                  (billingStatementDetail.Misc
                    ? billingStatementDetail.Misc
                    : 0)
                ).toFixed(2)
              : "0.00"
          }`,
          font: { bold: true },
        },
      ]);
      startColumn = addStyledCell(row, startColumn, [
        { text: "Miles\n", font: { bold: true } },
        {
          text: `(${
            billngStatementData[0]?.Miles.toFixed(2) || "0.00"
          }) miles * $${
            billngStatementData[0]?.MileageRate.toFixed(3) || "0.00"
          } / mile\n`,
        },
        {
          text: `$${
            (billngStatementData[0]?.Miles || 0) *
            (billngStatementData[0]?.MileageRate || 0)
          }`,
          font: { bold: true },
        },
      ]);
      startColumn = addStyledCell(row, startColumn, [
        { text: "Total Owed\n", font: { bold: true } },
        {
          text: "total owed to broker\n",
        },
        {
          text: `$${overAllTotal || "0.00"}`,
          font: { bold: true },
        },
      ]);

      wsData.addRow([]);

      wsData.addRow([]);

      // Table Headers
      const haeadrsCss = wsData.addRow([
        "Date",
        "Type",
        "Hours",
        "Miles",
        "Lodging",
        "Copies",
        "Misc",
        "Per Diem",
        "Description",
      ]);

      haeadrsCss.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "58a84a" }, // Light gray color (use hex ARGB format)
        };
        cell.font = {
          bold: true, // Optional: Make the text bold for better visibility
          color: { argb: "FFFFFFFF" },
        };
        cell.alignment = {
          vertical: "middle", // Center vertically
          horizontal: "center", // Center horizontally
        };
      });

      // Table Data
      // Updated breakString function to handle null or undefined
      const breakString = (str, length) => {
        if (!str) return ""; // Return an empty string if str is null or undefined
        return str.match(new RegExp(`.{1,${length}}`, "g")).join("\n");
      };

      billngStatementTableData
        .filter((item) => item.BillingType !== 0)
        .sort((a, b) => {
          if (a.BillingDetailsID !== b.BillingDetailsID) {
            return a.BillingDetailsID - b.BillingDetailsID;
          }
          return new Date(a.Date) - new Date(b.Date);
        })
        .forEach((detail) => {
          // Ensure detail.Description is a string and handle null/undefined
          const description = detail.Description
            ? breakString(detail.Description.toString(), 40)
            : "No Description";

          const tableRow = wsData.addRow([
            `${moment(detail.Date).utc().format("MM/DD/YYYY")}`,
            `${
              billTypeList.find((row) => row.id === detail.BillingType)
                ? billTypeList.find((row) => row.id === detail.BillingType).name
                : "Unknown"
            }`,
            detail.Hours.toFixed(2),
            detail.Miles.toFixed(2),
            `$${detail.Lodging.toFixed(2)}`,
            `$${detail.Copies.toFixed(2)}`,
            `$${detail.Misc.toFixed(2)}`,
            `$${detail.PerDiem.toFixed(2)}`,
            description, // Use the processed description
          ]);

          const descriptionColumnIndex = 9;

          wsData.getColumn(descriptionColumnIndex).width = 40; // Adjust the width as needed
          wsData.getColumn(descriptionColumnIndex).alignment = {
            vertical: "middle",
            horizontal: "center",
            wrapText: true,
          };

          // Adjust row height for wrapped text
          const row = wsData.getRow(tableRow.number);
          row.height = 30; // Adjust height based on content length

          // Apply border and alignment to each cell
          tableRow.eachCell((cell, colNumber) => {
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };

            cell.alignment = {
              vertical: "middle",
              horizontal: "center",
              wrapText: true,
            };
          });
        });

      const totalvalues = wsData.addRow([
        "Total",
        "",
        `${billngStatementTableData
          .reduce((sum, row) => sum + (row.Hours || 0), 0)
          .toFixed(2)}`,
        `${billngStatementTableData
          .reduce((sum, row) => sum + (row.Miles || 0), 0)
          .toFixed(2)}`,
        `$${billngStatementTableData
          .reduce((sum, row) => sum + (row.Lodging || 0), 0)
          .toFixed(2)}`,
        `$${billngStatementTableData
          .reduce((sum, row) => sum + (row.Copies || 0), 0)
          .toFixed(2)}`,
        `$${billngStatementTableData
          .reduce((sum, row) => sum + (row.Misc || 0), 0)
          .toFixed(2)}`,
        `$${billngStatementTableData
          .reduce((sum, row) => sum + (row.PerDiem || 0), 0)
          .toFixed(2)}`,
        "",
      ]);

      totalvalues.eachCell((cell) => {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });

      wsData.getRow(totalvalues.number).eachCell((cell) => {
        cell.alignment = { vertical: "middle", horizontal: "center" };
        cell.font = { bold: true, color: { argb: "000000" } }; // Example formatting for emphasis
      });

      wsData.addRow([]);
      wsData.addRow([]);

      // Footer
      wsData.addRow([
        "",
        `© 2018. HOS Resources, LLC. All Rights Reserved. 910 Harding Street Lafayette, LA 70503 337-296-8032 www.hosresources.com`,
      ]);

      wsData.addRow([]);

      const officeDetails = wsData.addRow([
        "", // Placeholder for alignment
        "📍 910 Harding Street\nLafayette, LA 70503",
        "", // Placeholder for alignment
        "📬 P.O. Box 51794\nLafayette, LA 70505",
        "", // Placeholder for alignment
        "📞 337.889.8940",
        "", // Placeholder for alignment
        "🌐 www.hosresources.com",
      ]);

      // Merge cells to span the content across two columns
      // Merge cells to span the content across two columns for each block of content
      wsData.mergeCells(officeDetails.number, 2, officeDetails.number, 3); // Merge columns 2 and 3
      wsData.mergeCells(officeDetails.number, 4, officeDetails.number, 5); // Merge columns 4 and 5
      wsData.mergeCells(officeDetails.number, 6, officeDetails.number, 7); // Merge columns 6 and 7
      wsData.mergeCells(officeDetails.number, 8, officeDetails.number, 9); // Merge columns 6 and 7

      officeDetails.eachCell((cell, colNumber) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "58a84a" }, // Background color (green)
        };
        cell.font = {
          bold: true,
          color: { argb: "FFFFFFFF" }, // White font color
        };

        cell.alignment = {
          vertical: "middle",
          horizontal: "center", // Center content horizontally
          wrapText: true, // Wrap text for all cells
        };
      });

      officeDetails.height = 30;

      // Optionally, set the width of the columns to ensure all content fits well and is visible.
      wsData.columns.forEach((col) => {
        col.width = 18; // You can adjust this width for all columns as needed
      });

      try {
        // Write to file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "BillingStatement.xlsx";
        a.click();
      } catch (error) {
        console.error("Error writing Excel file:", error);
      }
      setLoading(false);
      setFullPageView(false);
      setDownloadType("Save as");
    } catch (error) {
      console.error("Error exporting file:", error);
    }
  };

  return (
    <div id="samplechk">
      <Box sx={{ display: "-webkit-box" }}>
        <Box component="main" sx={{ flexGrow: 1, p: "18px 20px" }}>
          <Box className="bg-box invoicepdfbg-box">
            <Grid className="pdf-top-header" container spacing={2}>
              <Grid
                sx={{ pt: "0px !important", my: "auto" }}
                item
                xs={12}
                md={7}
              >
                <Stack alignItems="center" direction="row" spacing={2}>
                  <span
                    className="material-symbols-outlined"
                    onClick={handleFirstPage}
                    disabled={currentPage == 0}
                    style={{
                      cursor: currentPage == 0 ? "" : "pointer",
                      color: currentPage == 0 ? "lightgray" : "",
                    }}
                  >
                    skip_previous
                  </span>
                  <span
                    className="material-symbols-outlined"
                    style={{
                      cursor: currentPage == 0 ? "" : "pointer",
                      color: currentPage == 0 ? "lightgray" : "",
                    }}
                    onClick={handlePreviousPage}
                    disabled={currentPage == 0}
                  >
                    chevron_left
                  </span>
                  <span className="pagination-text active-num">
                    {currentPage + 1}
                  </span>
                  <span className="pagination-text">of {totalPages}</span>
                  <span
                    className="material-symbols-outlined"
                    style={{
                      cursor: totalPages - 1 === currentPage ? "" : "pointer",
                      color: totalPages - 1 === currentPage ? "lightgray" : "",
                    }}
                    onClick={handleNextPage}
                    disabled={totalPages - 1 === currentPage}
                  >
                    chevron_right
                  </span>
                  <span
                    style={{
                      cursor: totalPages - 1 === currentPage ? "" : "pointer",
                      color: totalPages - 1 === currentPage ? "lightgray" : "",
                    }}
                    className="material-symbols-outlined"
                    onClick={handleLastPage}
                    disabled={totalPages - 1 === currentPage}
                  >
                    skip_next
                  </span>
                  <span
                    className="material-symbols-outlined reload-pdf"
                    onClick={pageLoad}
                    style={{ cursor: "pointer" }}
                  >
                    refresh
                  </span>
                  {/* <span className="material-symbols-outlined" 
                  onClick={() => {
                    navigate(`/statement/${billingStatementId}`);
                  }}
                  style={{cursor: 'pointer'}}
                  >arrow_back</span> */}
                </Stack>
              </Grid>
              <Grid sx={{ pt: "0px !important" }} item xs={12} md={5}>
                <Stack direction="row" spacing={0}>
                  <FormControl className="whole-select" fullWidth>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={zoomPgae}
                      onChange={handleChangeZoomPage}
                    >
                      <MenuItem value={0.01}>Whole Page</MenuItem>
                      <MenuItem value={500}>500 %</MenuItem>
                      <MenuItem value={200}>200 %</MenuItem>
                      <MenuItem value={150}>150 %</MenuItem>
                      <MenuItem value={0}>100 %</MenuItem>
                      <MenuItem value={-10}>75 %</MenuItem>
                      <MenuItem value={-25}>50 %</MenuItem>
                      <MenuItem value={-50}>25 %</MenuItem>
                      <MenuItem value={-75}>10 %</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl
                    className={
                      billngStatementTableData.length === 0
                        ? "disabled-saveas-btn"
                        : "saveas-btn"
                    }
                    fullWidth
                  >
                    <Select
                      id="demo-simple-select"
                      startAdornment={
                        <InputAdornment position="start">
                          <span className="material-symbols-outlined">
                            save
                          </span>
                        </InputAdornment>
                      }
                      value={downloadType}
                      onChange={handleChangeDownloadType}
                      disabled={billngStatementTableData.length === 0}
                    >
                      <MenuItem value={"Save as"}>Save as</MenuItem>
                      <MenuItem value={"PDF"}>PDF</MenuItem>
                      <MenuItem value={"EXCEL"}>EXCEL</MenuItem>
                      <MenuItem value={"DOC"}>WORD</MenuItem>
                      <MenuItem value={"IMAGE"}>IMAGE</MenuItem>
                    </Select>
                  </FormControl>
                  <Button
                    className="primary-btn save-print-btn"
                    onClick={() => {
                      setFullPageView(true);
                      setTimeout(() => {
                        handlePrint();
                      }, 2000);
                    }}
                    disabled={billngStatementTableData.length === 0}
                  >
                    <span className="material-symbols-outlined">print</span>
                  </Button>
                </Stack>
              </Grid>
            </Grid>
            <div
              style={
                zoomPgae
                  ? {
                      overflow: zoomPgae != "0.01" ? "scroll" : "",
                      width: "100%",
                      height: "100%",
                      backgroundColor: "#fff",
                    }
                  : {}
              }
            >
              <div
                ref={captureRef}
                id="capturediv"
                style={
                  zoomPgae
                    ? {
                        transform: `scale(${zoomPgae / 100 + 1})`,
                        transformOrigin: "0 0",
                      }
                    : {}
                }
              >
                <Stack
                  sx={{ mt: "27px" }}
                  direction="row"
                  justifyContent="space-between"
                  spacing={2}
                >
                  <img src={pdfMainLogo} />
                  <Box
                    sx={{
                      borderRight: "4px solid green",
                      paddingRight: "10px",
                      mt: "auto !important",
                      mb: "auto !important",
                    }}
                  >
                    <Typography className="total-due">TOTAL DUE</Typography>
                    <Typography className="total-amount">
                      ${overAllTotal ? overAllTotal : "0.00"}
                    </Typography>
                  </Box>
                </Stack>
                <Grid
                  sx={{
                    padding: "12px 13px",
                    background: "#F6F7F9",
                    mt: "20px",
                    borderBottom: "1px solid #E3E5E8",
                  }}
                  container
                >
                  <Grid item xs={12} md={6}>
                    <Typography className="preview-bill-date">
                      {billngStatementData && billngStatementData.length > 0
                        ? `Billing Statement: ${moment(
                            billngStatementData[0].BillingStart
                          )
                            .utc()
                            .format("MM/DD/YYYY")} - ${moment(
                            billngStatementData[0].BillingEnd
                          )
                            .utc()
                            .format("MM/DD/YYYY")}`
                        : "No billing statement available."}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography
                      sx={{ textAlign: "right" }}
                      className="preview-bill-date"
                    >
                      Print Date - {currentPrintDate}
                    </Typography>
                  </Grid>
                </Grid>
                <Box
                  sx={{
                    border: "1px solid #E0E2E7",
                    borderRadius: "12px",
                    padding: "15px",
                    paddingTop: "0px",
                    marginTop: "15px",
                  }}
                >
                  <TableContainer
                    component={Paper}
                    sx={{ marginTop: "5px" }}
                    className="preview-table"
                  >
                    <Table
                      sx={{
                        [`& .${tableCellClasses.root}`]: {
                          borderBottom: "none",
                        },
                      }}
                    >
                      <TableBody>
                        <TableRow
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell sx={{ pl: "0px" }}>
                            <Typography className="address-title">
                              {billngStatementData[0]
                                ? billngStatementData[0].ProjectName
                                : ""}{" "}
                              {billngStatementData[0]
                                ? "(" + billngStatementData[0].ProjectID + ")"
                                : ""}
                            </Typography>
                            <Typography className="address-text">
                              {customerDetail ? customerDetail.Name : ""}
                            </Typography>
                            <Typography
                              sx={{ wordBreak: "break-word" }}
                              className="address-text"
                            >
                              {customerDetail &&
                              customerDetail.ContactOfficePhone
                                ? customerDetail.ContactOfficePhone + ", "
                                : ""}{" "}
                              {customerDetail &&
                              customerDetail.ContactMobilePhone
                                ? customerDetail.ContactMobilePhone
                                : ""}
                              {customerDetail &&
                              (customerDetail.ContactOfficePhone ||
                                customerDetail.ContactMobilePhone)
                                ? " | "
                                : ""}
                              {customerDetail
                                ? customerDetail.ContactEmail
                                : ""}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography
                              className="address-title"
                              sx={{ textAlign: "right" }}
                            >
                              {brokerDetail ? brokerDetail.FirstName : ""}{" "}
                              {brokerDetail ? brokerDetail.LastName : ""}
                            </Typography>
                            {/* <Typography
                            className="address-text"
                            sx={{ textAlign: "right" }}
                          >
                            {brokerDetail ? brokerDetail.Email : ""}
                          </Typography> */}
                            <Typography
                              className="address-text"
                              sx={{ textAlign: "right" }}
                            >
                              {brokerDetail ? brokerDetail.PhoneNumber : ""}
                              {brokerDetail && brokerDetail.Email
                                ? " | " + brokerDetail.Email
                                : ""}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {/* <Grid
              sx={{
                mt: "28px",
              }}
              container
            >
              <Grid item xs={12} md={6}>
                <Typography className="address-title">
                  {billngStatementData[0] ? billngStatementData[0].ProjectName: "" }
                  {billngStatementData[0] ? "("+ billngStatementData[0].ProjectID +")": "" }
                </Typography>
                <Typography className="address-text">{customerDetail ? customerDetail.Name: "" }</Typography>
                <Typography className="address-text">
                {customerDetail && customerDetail.ContactOfficePhone ? customerDetail.ContactOfficePhone + ", ": "" } {customerDetail && customerDetail.ContactMobilePhone ? customerDetail.ContactMobilePhone: "" } 

                {customerDetail && (customerDetail.ContactOfficePhone || customerDetail.ContactMobilePhone) ? " | ": "" } 
                
                {customerDetail ? customerDetail.ContactEmail: "" }
                </Typography>
              </Grid>
              <Grid sx={{ textAlign: "right" }} item xs={12} md={6}>
                <Typography className="address-title">
                {brokerDetail ? brokerDetail.FirstName: "" } 
                  {brokerDetail ? brokerDetail.LastName: "" }
                </Typography>
                <Typography className="address-text">
                  {brokerDetail ? brokerDetail.Email: "" }
                  </Typography>
                <Typography className="address-text">
                  {brokerDetail ? brokerDetail.PhoneNumber: "" }  
                  {brokerDetail && brokerDetail.Email ? " | "+ brokerDetail.Email: "" }
                </Typography>
              </Grid>
            </Grid> */}

                  <Stack
                    className="hours-box"
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{ mt: "0px" }}
                  >
                    <Box>
                      <Typography className="hour-title">Hours</Typography>
                      <Typography className="hour-text">
                        sum of all hours
                      </Typography>
                      <Typography className="hour-charge">
                        {billingStatementDetail
                          ? billingStatementDetail.Hours.toFixed(2)
                          : 0.0}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography className="hour-title">Day Rate</Typography>
                      <Typography className="hour-text">
                        amt paid per 8 hours
                      </Typography>
                      <Typography className="hour-charge">
                        $
                        {billingStatementDetail && dayRateMillageRateForBilling
                          ? billingStatementDetail.DayRate ==
                              dayRateMillageRateForBilling?.brokerBilling
                                ?.dayRate ||
                            billingStatementDetail?.StatusID != 1
                            ? billingStatementDetail.DayRate.toFixed(2)
                            : dayRateMillageRateForBilling?.brokerBilling
                                ?.dayRate
                          : 0.0}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography className="hour-title">Per Diem</Typography>
                      <Typography className="hour-text">
                        total per diem
                      </Typography>
                      <Typography className="hour-charge">
                        $
                        {billingStatementDetail
                          ? billingStatementDetail.PerDiem.toFixed(2)
                          : 0.0}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography className="hour-title">Expenses</Typography>
                      <Typography className="hour-text">
                        lodging, copies & misc
                      </Typography>
                      <Typography className="hour-charge">
                        $
                        {billingStatementDetail
                          ? (
                              (billingStatementDetail.Copies
                                ? billingStatementDetail.Copies
                                : 0) +
                              (billingStatementDetail.Lodging
                                ? billingStatementDetail.Lodging
                                : 0) +
                              (billingStatementDetail.Misc
                                ? billingStatementDetail.Misc
                                : 0)
                            ).toFixed(2)
                          : "0.00"}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography className="hour-title">Miles</Typography>
                      <Typography className="hour-text">
                        {billingStatementDetail
                          ? billingStatementDetail.Miles.toFixed(2)
                          : 0.0}{" "}
                        miles * $
                        {(billingStatementDetail &&
                          billingStatementDetail?.MileageRate ===
                            dayRateMillageRateForBilling?.brokerBilling
                              ?.millageRate) ||
                        billingStatementDetail?.StatusID !== 1
                          ? billingStatementDetail?.MileageRate?.toFixed(3)
                          : dayRateMillageRateForBilling?.brokerBilling
                              ?.millageRate || 0.0}
                        / mile
                      </Typography>
                      <Typography className="hour-charge">
                        $
                        {billingStatementDetail
                          ? (
                              (billingStatementDetail.Miles
                                ? billingStatementDetail.Miles
                                : 0) *
                              (billingStatementDetail?.MileageRate ===
                                dayRateMillageRateForBilling?.brokerBilling
                                  ?.millageRate ||
                              billingStatementDetail?.StatusID !== 1
                                ? billingStatementDetail?.MileageRate.toFixed(3)
                                : dayRateMillageRateForBilling?.brokerBilling
                                    ?.millageRate || 0.0)
                            ).toFixed(3)
                          : "0.00"}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography className="hour-title">Total Owed</Typography>
                      <Typography className="hour-text">
                        total owed to broker
                      </Typography>
                      <Typography className="hour-charge">
                        ${overAllTotal ? overAllTotal : "0.00"}
                      </Typography>
                    </Box>
                  </Stack>
                </Box>
                <TableContainer
                  sx={{ minHeight: "400px" }}
                  className="preview-table"
                  component={Paper}
                >
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>Date</TableCell>
                        <TableCell>Type</TableCell>
                        <TableCell>Hours</TableCell>
                        <TableCell>Miles</TableCell>
                        <TableCell>Lodging</TableCell>
                        <TableCell>Copies</TableCell>
                        <TableCell>Misc</TableCell>
                        <TableCell sx={{ minWidth: "54px" }}>
                          Per Diem
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {fullPageView == false
                        ? currentPageData &&
                          currentPageData.length > 0 &&
                          currentPageData
                            .filter((item) => item.BillingType !== 0)
                            .sort((a, b) => {
                              // First sort by BillingDetailsID
                              if (a.BillingDetailsID == b.BillingDetailsID) {
                                return a.BillingDetailsID - b.BillingDetailsID;
                              }
                              // If BillingDetailsID is the same, sort by Date
                              return new Date(a.Date) - new Date(b.Date);
                            })
                            .map((billingDetail) => (
                              <TableRow
                                key={billingDetail.billingStatementDetailsId}
                              >
                                <TableCell>
                                  <span>
                                    {moment(billingDetail.Date)
                                      .utc()
                                      .format("MM/DD/YYYY")}
                                  </span>
                                  <br />
                                  <span
                                    style={{ lineBreak: "anywhere" }}
                                    className="pv-description"
                                  >
                                    {billingDetail.Description ||
                                      "No Description"}
                                  </span>
                                </TableCell>
                                <TableCell>
                                  {billTypeList.find(
                                    (row) =>
                                      row.id === billingDetail.BillingType
                                  )
                                    ? billTypeList.find(
                                        (row) =>
                                          row.id === billingDetail.BillingType
                                      ).name
                                    : "--"}
                                </TableCell>
                                <TableCell>
                                  {billingDetail.Hours.toFixed(2)}
                                </TableCell>
                                <TableCell>
                                  {billingDetail.Miles.toFixed(2)}
                                </TableCell>
                                <TableCell>
                                  ${billingDetail.Lodging.toFixed(2)}
                                </TableCell>
                                <TableCell>
                                  ${billingDetail.Copies.toFixed(2)}
                                </TableCell>
                                <TableCell>
                                  ${billingDetail.Misc.toFixed(2)}
                                </TableCell>
                                <TableCell>
                                  ${billingDetail.PerDiem.toFixed(2)}
                                </TableCell>
                              </TableRow>
                            ))
                        : billngStatementTableData &&
                          billngStatementTableData.length > 0 &&
                          billngStatementTableData
                            .filter((item) => item.BillingType !== 0)
                            .sort((a, b) => {
                              // First sort by BillingDetailsID
                              if (a.BillingDetailsID !== b.BillingDetailsID) {
                                return a.BillingDetailsID - b.BillingDetailsID;
                              }
                              // If BillingDetailsID is the same, sort by Date
                              return new Date(a.Date) - new Date(b.Date);
                            })
                            .map((billingDetail) => (
                              <TableRow
                                key={billingDetail.billingStatementDetailsId}
                              >
                                <TableCell>
                                  <span>
                                    {moment(billingDetail.Date)
                                      .utc()
                                      .format("MM/DD/YYYY")}
                                  </span>
                                  <br />
                                  <span
                                    style={{ lineBreak: "anywhere" }}
                                    className="pv-description"
                                  >
                                    {billingDetail.Description ||
                                      "No Description"}
                                  </span>
                                </TableCell>
                                <TableCell>
                                  {billTypeList.find(
                                    (row) =>
                                      row.id === billingDetail.BillingType
                                  )
                                    ? billTypeList.find(
                                        (row) =>
                                          row.id === billingDetail.BillingType
                                      ).name
                                    : "--"}
                                </TableCell>
                                <TableCell>
                                  {billingDetail.Hours.toFixed(2)}
                                </TableCell>
                                <TableCell>
                                  {billingDetail.Miles.toFixed(2)}
                                </TableCell>
                                <TableCell>
                                  ${billingDetail.Lodging.toFixed(2)}
                                </TableCell>
                                <TableCell>
                                  ${billingDetail.Copies.toFixed(2)}
                                </TableCell>
                                <TableCell>
                                  ${billingDetail.Misc.toFixed(2)}
                                </TableCell>
                                <TableCell>
                                  ${billingDetail.PerDiem.toFixed(2)}
                                </TableCell>
                              </TableRow>
                            ))}
                      {/* Compute totals */}
                      {fullPageView != false ||
                      currentPage + 1 === totalPages ? (
                        <TableRow>
                          <TableCell colSpan={2}>
                            {" "}
                            <strong> Total </strong>
                          </TableCell>
                          <TableCell>
                            <strong>
                              {billngStatementTableData
                                .reduce((sum, row) => sum + (row.Hours || 0), 0)
                                .toFixed(2)}
                            </strong>
                          </TableCell>
                          <TableCell>
                            <strong>
                              {billngStatementTableData
                                .reduce((sum, row) => sum + (row.Miles || 0), 0)
                                .toFixed(2)}
                            </strong>
                          </TableCell>
                          <TableCell>
                            <strong>
                              $
                              {billngStatementTableData
                                .reduce(
                                  (sum, row) => sum + (row.Lodging || 0),
                                  0
                                )
                                .toFixed(2)}
                            </strong>
                          </TableCell>
                          <TableCell>
                            <strong>
                              $
                              {billngStatementTableData
                                .reduce(
                                  (sum, row) => sum + (row.Copies || 0),
                                  0
                                )
                                .toFixed(2)}
                            </strong>
                          </TableCell>
                          <TableCell>
                            <strong>
                              $
                              {billngStatementTableData
                                .reduce((sum, row) => sum + (row.Misc || 0), 0)
                                .toFixed(2)}
                            </strong>
                          </TableCell>
                          <TableCell>
                            <strong>
                              $
                              {billngStatementTableData
                                .reduce(
                                  (sum, row) => sum + (row.PerDiem || 0),
                                  0
                                )
                                .toFixed(2)}
                            </strong>
                          </TableCell>
                        </TableRow>
                      ) : (
                        ""
                      )}

                      {billngStatementTableData &&
                        billngStatementTableData.length === 0 && (
                          <TableRow>
                            <TableCell colSpan={8}>
                              <center>No Record Found</center>
                            </TableCell>
                          </TableRow>
                        )}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Typography className="address-bar">
                  © 2024. HOS Resources, LLC. All Rights Reserved. 910 Harding Street Lafayette, LA 70503 337-296-8032
                  www.hosresources.com
                </Typography>
                <Stack
                  direction="row"
                  spacing={2}
                  alignItems="flext-start"
                  justifyContent="space-between"
                  className="preview-footer"
                >
                  <Box>
                    <Stack direction="row" spacing={1} alignItems="flex-start">
                      <span class="material-symbols-outlined">location_on</span>
                      <Typography>
                      910 Harding Street <br />
                        Lafayette, LA 70503
                      </Typography>
                    </Stack>
                  </Box>
                  <Box>
                    <Stack direction="row" spacing={1} alignItems="flex-start">
                      <span class="material-symbols-outlined">mail</span>
                      <Typography>
                        P.O. Box 51794 <br />
                        Lafayette, LA 70505
                      </Typography>
                    </Stack>
                  </Box>
                  <Box>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <span class="material-symbols-outlined">call</span>
                      <Typography>337.889.8940</Typography>
                    </Stack>
                  </Box>
                  <Box>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <span class="material-symbols-outlined">public</span>
                      <Typography>www.hosresources.com</Typography>
                    </Stack>
                  </Box>
                </Stack>
              </div>
            </div>
            {loading && <CustomPageLoading />}
          </Box>
        </Box>
      </Box>
    </div>
  );
}
